export class MergeOverride {
    public key!: string
    public value!: string
}